export default {
  methods: {
    statusColor(status) {
      switch (status) {
        case "Waiting for payment":
          return "orange";
        case "Waiting for reconciliation":
          return "error";
        case "Draft":
          return "#555";
        case "Remaining payment":
        case "Partially reconciled":
          return "blue";
        case "Paid":
        case "Reconciled":
          return "success";
      }
    },
    statusIcon(status) {
      switch (status) {
        case "Waiting for payment":
          return "mdi-credit-card-clock-outline";
        case "Waiting for reconciliation":
          return "mdi-bank-remove";
        case "Draft":
          return "mdi-file-edit-outline";
        case "Remaining payment":
        case "Partially reconciled":
          return "mdi-check";
        case "Paid":
        case "Reconciled":
          return "mdi-check";
      }
    },
    statusLabel(reconciliation_status) {
      switch (reconciliation_status) {
        case "pending":
          return "Waiting for payment";
        case "pending_transaction":
          return "Waiting for reconciliation";
        case "partial":
          return "Remaining payment";
        case "done":
          return "Paid";
        case "partial_transaction":
          return "Partially reconciled";
        case "done_transaction":
          return "Reconciled";
      }
    }
  }
};
